import React, {useState} from 'react'
import moment from 'moment'
import _ from 'lodash';
import {
    AppBar,
    Button,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    Icon,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Popover,
    Select,
    TextField,
    Toolbar,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames';
import { useIntl } from 'src/common/razzle-platform-translate'
import AddressFilter from 'src/common/razzle-platform-map/components/filters/AddressFilter';
import RadiusFilter from 'src/common/razzle-platform-map/components/filters/RadiusFilter';
import CategoryFilter from 'src/common/razzle-platform-map/components/filters/CategoryFilter';
import { AVAILABILITY_FILTER_ACTIVE } from 'src/common/razzle-platform-map/configs'

let AvailabilityFilter
let AVAILABILITY_DATE_STRING_FORMAT

try {
    AvailabilityFilter = require('src/common/razzle-platform-reservation/Filters/AvailabilityFilter').default
    AVAILABILITY_DATE_STRING_FORMAT = require('src/common/razzle-platform-reservation/configs').AVAILABILITY_DATE_STRING_FORMAT
} catch (error) {}


const useStyles = makeStyles(theme => ({
    filterButton: {
        background: '#ffffff',
        color: '#000000',
        fontWeight: 400,
        '&:hover': {
            background: `${theme.palette.primary.main} !important`,
            color: `${theme.palette.primary.contrastText} !important`,
            borderColor: `${theme.palette.primary.main} !important`
        },
    },
    filterButtonActive: {
        background: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
    }
}))



function FiltersDialog(props) {
    const [anchorElId, setAnchorElId] = useState(null)
    const [anchorEl, setAnchorEl] = useState(null)
    const [collapseOpen, setCollapseOpen] = useState(false)
    const [filters_, setFilters_] = useState({})
    const [cleared, setCleared] = useState(false)
    const classes = useStyles()
    const { formatMessage } = useIntl()

    const {
        open, close, categories, states, cities, mapView, centerMap, mapSize,
        activities, saleTypes, specificities, bounds, filters, setFilter, applyFilter, cancelFilter,
        initializeFilters, isFilteringByCountry, setIsFilteringByCountry
    } = props


    const handleApplyFilter = () => {
        applyFilter(() => {
            const element = document.querySelector('#paperScrollTarget')
            element && element.scrollIntoView({block: 'nearest', inline: 'start'})
            props.close()
        })
    }

    const removeFilters = () => {
        initializeFilters()
        props.close()
    }

    const handleChange = (event, multi, isChecked, immediatelyFilter=false) => {
        if(multi){
            setFilter({[event.target.name]: _.isArray(event.target.value) ? event.target.value : [event.target.value]}, immediatelyFilter)
        }else{
            setFilter({[event.target.name]: isChecked ? undefined : event.target.value}, immediatelyFilter)
        }
    }


    const toggleCollapse = (category) => {
        let returnedChildren = []
        returnedChildren.push(category.id)
        // Loop through the subCategories of the given category
        category.subCategories.forEach(item => {
            // Add current category id to the array
            returnedChildren.push(item.id)
            // If the category also has subCategories call function using said category
            if(item.subCategories.length > 0){
                const subChildren = toggleCollapse(item)
                return returnedChildren = [...returnedChildren, ...subChildren]
            }
        })
        return _.uniq(returnedChildren)
    }

    const checkCollapse = (event, isChecked, category) => {
        setCleared(false)
        let nextState = {...filters_}
        const children = toggleCollapse(category)
        // If the collapse is not checked, add all of the categories of the selected category to the filter
        // If it's checked, remove each category fro mthe filter
        if(!isChecked){
            children.forEach(item => nextState = {
                ...nextState,
                [event.target.name]: nextState[event.target.name] ? [...nextState[event.target.name], item] : [item]
            })
            setFilters_(nextState)
        }else{
            children.forEach(item => nextState = {
                ...nextState,
                [event.target.name]: _.filter(nextState[event.target.name], (elem) => elem !== item)
            })
            setFilters_(nextState)
        }
    }

    const clearFilter = (key) => {
        if(Array.isArray(key)) {
            cancelFilter(key)
        }else{
            cancelFilter([key])
        }
        setCleared(true)
    }

    const openPopup = event => {
        setAnchorEl(event.currentTarget)
        setAnchorElId(event.currentTarget.id)
    }

    const closePopup = () => {
        setAnchorEl(null)
        setAnchorElId(null)
    }

    const addSpecificities = (category, rowSpecs) => {
        let specResults = []
        category.deepCategorySpecificities.forEach(spec => {
            const specificity = props.specificities.filter(item => spec.specificity.id === item.id)[0]
            if (rowSpecs) {
                specResults.push(specificity)
            } else {
                if (category.parentCategory) {
                    specResults.push(specificity)
                }
            }
        })

        return _.uniqWith(specResults, (arrVal, othVal) => arrVal.id === othVal.id)
    }

    const checkCategorySpeificities = (rowSpecs) => {
        if(filters['category.id'] && categories.length > 0 && !rowSpecs){
            let category = undefined

            if(typeof filters['category.id'] === 'string'){
                category = categories.filter(cat => cat.id === filters['category.id'])[0]
            }else{
                filters['category.id'].forEach(id => {
                    category = categories.filter(cat => cat.id === id)[0]
                })
            }

            return category ? addSpecificities(category) : []
        }else{
            const parentCategory = categories.filter(category => !category.parentCategory)[0]
            if(parentCategory){
                return addSpecificities(parentCategory, rowSpecs)
            }else{
                return []
            }
        }
    }

    const checkSelectedSpecFilters = (specificities, filters) => {
        let selected = false
        let keys = []
        specificities.forEach(spec => {
            if(spec.type === 'date'){
                keys.push(`productSpecificities.date_${spec.id}`)
            }else if(spec.type === 'm_list'){
                keys.push(`productSpecificities.choices_${spec.id}`)
            }else{
                keys.push(`productSpecificities.choice_${spec.id}`)
            }
        })

        keys.forEach(key => {
            if(filters.hasOwnProperty(key) && filters[key]){
                selected = true

            }
        })

        return selected
    }

    const handleSpecificity = (specificity) => {
        const specType = specificity.type === 'm_list' ? 'choices' : specificity.type === 'date' ? 'date' : 'choice'
        if (specificity.type === 'date') {
            return (
                <TextField
                    key={specificity.id}
                    label={specificity.name}
                    type="date"
                    className='mb-4'
                    name={`productSpecificities.${specType}_${specificity.id}`}
                    value={filters[`productSpecificities.${specType}_${specificity.id}`] || ''}
                    onChange={handleChange}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                />
            )
        } else if (specificity.type === 'str') {
            const filterSpecSelected = filters.hasOwnProperty(`productSpecificities.${specType}_${specificity.id}`) && filters[`productSpecificities.${specType}_${specificity.id}`]
            return (
                <Button
                    onClick={() => {
                        if (filterSpecSelected) {
                            clearFilter(`productSpecificities.${specType}_${specificity.id}`)
                        } else {
                            setFilters({
                                ...filters,
                                [`productSpecificities.${specType}_${specificity.id}`]: specificity.id
                            })
                        }
                    }}
                    variant="outlined"
                    size="medium"
                    className={classNames(
                        filters[`productSpecificities.${specType}_${specificity.id}`] || filterSpecSelected ? 'bg-green-500 text-white border-white' : '',
                        'py-3 mb-4 hover:bg-gray-600 hover:text-white w-full'
                    )}
                >
                    <Typography>{specificity.name}</Typography>
                </Button>
            )
        } else {
            const specValues = filters[`productSpecificities.${specType}_${specificity.id}`] || []
            return (
                <FormControl key={specificity.id} className="mb-4" variant="outlined" fullWidth>
                    <InputLabel className="bg-white" htmlFor="option-value">
                        {specificity.name}
                    </InputLabel>
                    <Select
                        name={`productSpecificities.${specType}_${specificity.id}`}
                        value={typeof specValues === 'string' ? specValues.split(',') : specValues}
                        required
                        multiple
                        input={<OutlinedInput labelWidth={specificity.name * 8} id="option-value" />}
                    >
                        {specificity.choices && specificity.choices.map(choice => {
                            return (
                                <MenuItem
                                    key={choice.value}
                                    value={choice.value}
                                    onClick={event =>   handleChange({target: {
                                        name: `productSpecificities.${specType}_${specificity.id}`,
                                        value: event.target.dataset['value']
                                    }}, true, null, false)}
                                    >
                                    {choice.label}
                                </MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
            )
        }
    }

    const openPoper = Boolean(anchorEl);

    const buttonSpecificities = (specificities && checkCategorySpeificities(true)) || []
    const moreSpecificities = (specificities && checkCategorySpeificities(false).filter(item => buttonSpecificities.indexOf(item) < 0)) || []

    return(
        <Dialog
            fullScreen
            onClose={close}
            open={open}
        >
            <DialogTitle component="div" className="p-0" style={{ padding: 0 }}>
                <AppBar position="static" elevation={2} className="bg-white">
                    <Toolbar className="flex justify-between">
                        <div className="flex items-center">
                            <Button onClick={removeFilters} variant="outlined" className="text-blue-400 border-blue-400">
                                <Typography>{formatMessage({ id: 'Clear', defaultMessage: 'Clear' })}</Typography>
                            </Button>
                        </div>
                        <div className="flex items-center justify-end">
                            <IconButton onClick={close}>
                                <Icon className="text-3xl pr-0">close</Icon>
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>
            </DialogTitle>
            <DialogContent>
                <div className="flex flex-col">
                    <div className="text-center mb-4 mt-4">
                        <Typography variant="h3">{formatMessage({ id: 'Filters', defaultMessage: 'Filters' })}</Typography>
                    </div>

                    <div className="flex items-center mb-4 mt-4">
                        <AddressFilter
                            values={filters}
                            clearFilter={clearFilter}
                            centerMap={centerMap}
                            mapSize={mapSize}
                            mapView={mapView}
                            isMobile={true}
                            setFilter={setFilter}
                            applyFilter={applyFilter}
                            isFilteringByCountry={isFilteringByCountry}
                            setIsFilteringByCountry={setIsFilteringByCountry}
                        />
                    </div>

                    {!mapView && !isFilteringByCountry && <div className="flex items-center">
                        <RadiusFilter
                            values={filters}
                            handleChange={handleChange}
                            isMobile={true}
                        />
                    </div>}

                    <div className="flex items-center mb-4 mt-4">
                        <TextField
                            label={formatMessage({ id: 'Search', defaultMessage: 'Search' })}
                            type="text"
                            name="search"
                            value={filters.search || ''}
                            onChange={handleChange}
                            variant="outlined"
                            fullWidth
                        />
                    </div>
                    <div>
                        <div className="mb-2 ml-4">
                            <Typography variant="h6">{formatMessage({ id: 'Price', defaultMessage: 'Price' })}</Typography>
                        </div>
                        <div className="flex items-center mb-4">
                            <TextField
                                label={formatMessage({ id: 'Min', defaultMessage: 'Min' })}
                                type="number"
                                name="gePrice"
                                value={filters.gePrice || ''}
                                onChange={handleChange}
                                variant="outlined"
                                fullWidth
                            />
                        </div>

                        <div className="flex items-center mb-4">
                            <TextField
                                label={formatMessage({ id: 'Max', defaultMessage: 'Max'})}
                                type="number"
                                name="lePrice"
                                value={filters.lePrice || ''}
                                onChange={handleChange}
                                variant="outlined"
                                fullWidth
                            />
                        </div>
                    </div>
                    { AvailabilityFilter && AVAILABILITY_FILTER_ACTIVE &&
                        <div className="flex items-center mb-4">
                            <Button
                                id="availabilityFilter"
                                onClick={event => openPopup(event)}
                                variant="outlined"
                                size="large"
                                className={classNames(
                                    (anchorElId === 'availabilityFilter') || (filters['availabilities.leStartDate'] && filters['availabilities.geEndDate']) ? classes.filterButtonActive : '',
                                    classes.filterButton,
                                    'w-full p-3'
                                )}
                            >
                                {(filters['availabilities.leStartDate'] && filters['availabilities.geEndDate']) ?
                                    <>{filters['availabilities.geEndDate']}<Icon className="text-lg ml-2 mr-2">arrow_forward</Icon>{filters['availabilities.leStartDate']}</> :
                                    <Typography>{formatMessage({ id: 'Disponibilité', defaultMessage: 'Disponibilité'})}</Typography>}
                            </Button>
                        </div>
                    }

                    <div className="flex items-center mb-4">
                        <Button
                            id="categoryFilter"
                            onClick={event => openPopup(event)}
                            variant="outlined"
                            size="large"
                            className='w-full p-3'
                        >
                            {filters['category.id'] && filters['category.id'].length > 1 ?
                                <>
                                    <Typography>{formatMessage({ id: 'Category', defaultMessage: 'Category'})}</Typography>
                                    <span className="mx-1"> - </span>
                                    {filters['category.id'].length}
                                </>
                                : filters['category.id'] && filters['category.id'].length === 1 ?
                                    <>
                                        <Typography>{formatMessage({ id: 'Category', defaultMessage: 'Category'})}</Typography>
                                        <span className="mx-1"> - </span>
                                        {categories.filter(item => item.id === filters['category.id'][0])[0].name}
                                    </>
                                : <Typography>{formatMessage({ id: 'Category', defaultMessage: 'Category'})}</Typography>
                            }
                        </Button>
                    </div>

                    {buttonSpecificities.length > 0 && <div className="mb-4">
                        <Typography variant="h6" className="mb-4 ml-4">{formatMessage({ id: 'Specificities', defaultMessage: 'Specificities'})}</Typography>
                        {buttonSpecificities.map(specificity => {
                            return handleSpecificity(specificity)
                        })}
                    </div>}

                    {moreSpecificities.length > 0 && <>
                        <Button
                            variant="text"
                            size="medium"
                            className="flex justify-between w-full mb-4"
                            onClick={() => setCollapseOpen(!collapseOpen)}
                        >
                            <Typography>{formatMessage({ id: 'Specificities', defaultMessage: 'Specificities'})}</Typography>
                            <Icon>{collapseOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
                        </Button>
                        <Collapse in={collapseOpen}>
                            {collapseOpen && moreSpecificities.map(specificity => {
                                return handleSpecificity(specificity)
                            })}
                        </Collapse>
                    </>}
                </div>
                {openPoper && anchorElId && <Popover
                    id="simple-popover"
                    open={openPoper}
                    anchorEl={anchorEl}
                    onClose={closePopup}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    >
                        {anchorElId === 'categoryFilter' &&
                            <CategoryFilter
                                isMobile={true}
                                categories={categories}
                                values={filters}
                                handleChange={handleChange}
                                clearFilter={clearFilter}
                                save={handleApplyFilter}
                                checkCollapse={checkCollapse}
                            />
                        }
                        { AvailabilityFilter && anchorElId === 'availabilityFilter' &&
                            <AvailabilityFilter
                                isMobile={true}
                                onSave={() => {
                                    applyFilter()
                                    props.close()
                                }}
                                startDate={filters['availabilities.geEndDate'] ? moment(filters['availabilities.geEndDate'], AVAILABILITY_DATE_STRING_FORMAT) : null}
                                endDate={filters['availabilities.leStartDate'] ? moment(filters['availabilities.leStartDate'], AVAILABILITY_DATE_STRING_FORMAT) : null}
                                onChange={({startDate, endDate, ...rest}) => {
                                    setFilter({
                                        ...startDate ? {'availabilities.geEndDate': startDate} : null ,
                                        ...endDate ? {'availabilities.leStartDate':  endDate} : null,
                                        ...rest
                                    })
                                }}
                                // In the database, we have availabilities that have multiple days in the interval start-end_date
                                // if we use the filter start_date <= availabilities <= end_date this will get only the availabilities that are in the interval but if we have an availability that start with the correct day and ends with a date bigger than the end_date that availability will not be included
                                // to resolve this issue we adjusted the filter to get availabilities start_date less than the selected end date and availabilities end_date greater than the selected start date                        
                                onClear={() => clearFilter(Object.keys(filters).filter(key => _.startsWith(key, 'availabilities')), true)}
                                extraAvailabilityFilters={props.extraAvailabilityFilters}
                                filters={filters}
                                clearFilter={clearFilter}
                            />
                        }

                    </Popover>
                }
            </DialogContent>
            <DialogActions>
                <Grid container>
                    <Grid container item xs={12} justify="center">
                        <Button
                            onClick={handleApplyFilter}
                            variant="contained"
                            color="primary"
                            style={{width: '20rem', height: '3rem'}}
                        >
                            <Typography>{formatMessage({ id: 'Save', defaultMessage: 'Save'})}</Typography>
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default FiltersDialog
